import * as React from 'react';
import { get } from 'lodash';
import { reduxForm } from 'redux-form';
import { Grid, Row, Col } from 'react-flexbox-grid';
import Divider from 'material-ui/Divider';
import { withState } from 'recompose';

import Button from '@inqool/uas-web-core/es/components/controls/Button';
import { RemoteAutoCompleteField, RemoteAutoComplete, InputField, Input } from '@components/form';
import { compose, withHandlers } from 'recompose';
import { isPositive, required } from '@utils/validators';
import { Loader } from '@components/loader';
import { withNotifications } from '@components/hoc/withNotifications';
import { operationalWarehouseAction } from './_operationalWarehouseActions';

const FORM_NAME = 'module-operational-warehouse-items';

const enhance = compose<any, any>(
  withState('loader', 'setLoader', false),
  withNotifications({ operationalWarehouseAction }),
  withHandlers({
    onSubmit: ({
      closeItem,
      url,
      successMessage,
      errorMessage,
      setLoader,
      operationalWarehouseActionNotify,
      refresh
    }) => async ({ category, warehouse, amount, firstNumber }) => {
      setLoader(true);
      const ok = await operationalWarehouseActionNotify(url, successMessage, errorMessage, {
        categoryId: category.id,
        warehouseId: warehouse.id,
        amount: Number(amount),
        firstNumber: Number(firstNumber)
      });
      setLoader(false);

      if (ok) {
        closeItem();
        refresh();
      }
    }
  }),
  reduxForm({ form: FORM_NAME })
);

export const View = ({ label, handleSubmit, closeItem, loader }) => {
  return (
    <form className="layout" onSubmit={handleSubmit}>
      {loader && <Loader />}
      <Grid fluid={true}>
        <Row>
          <Col className="grid-system-margin" />
        </Row>
        <Row>
          <Col xs={12}>
            <h3>{label}</h3>
          </Col>
        </Row>
        <Row>
          <Col xs={12} md={6} xl={4}>
            <RemoteAutoCompleteField
              component={RemoteAutoComplete}
              id="category"
              name="category"
              label="Kategorie *"
              url="/metropolis/api/owa/item/category"
              labelFunction={o => get(o, 'name')}
              fullWidth={true}
              validate={[required]}
            />
          </Col>
          <Col xs={12} md={6} xl={4}>
            <RemoteAutoCompleteField
              component={RemoteAutoComplete}
              id="warehouse"
              name="warehouse"
              label="Sklad *"
              url="/metropolis/api/owa/warehouse"
              labelFunction={o => get(o, 'name')}
              fullWidth={true}
              validate={[required]}
            />
          </Col>
        </Row>
        <Row>
          <Col xs={12} md={6} xl={4}>
            <InputField
              component={Input}
              id="amount"
              name="amount"
              label="Počet *"
              type="number"
              validate={[required, isPositive]}
            />
          </Col>
          <Col xs={12} md={6} xl={4}>
            <InputField
              component={Input}
              id="firstNumber"
              name="firstNumber"
              label="Identifikátor prvního předmětu *"
              type="number"
              validate={[required, isPositive]}
            />
          </Col>
        </Row>
      </Grid>

      <Divider />

      <Button type="submit" label="Potvrdit" primary={true} style={{ margin: '16px 0 16px 16px' }} />
      <Button label="Zrušit" style={{ margin: '16px 0 16px 16px' }} onClick={closeItem} />
    </form>
  );
};

export const OperationalWarehouseItemsForm = enhance(View);



// WEBPACK FOOTER //
// ./src/modules/operationalWarehouse/operationalWarehouseItemsForm.tsx